import React from 'react'
import { BiChevronLeft, BiChevronLeftCircle, BiSolidChevronLeft, BiSolidChevronLeftCircle } from 'react-icons/bi'
import { FiArrowLeftCircle } from 'react-icons/fi'
import { Link, useNavigate } from 'react-router-dom'

export default function Header({title,RightContent,parentLink='',parentTitle=''}) {
  const navigate = useNavigate();
  return (
    <div className=' px-4 pl-6 py-4 bg-white flex justify-between items-center border-b  border-b-[#e3e3e3] relative'>
      <div className='absolute -left-5 top-1/2 -translate-y-1/2 cursor-pointer' onClick={()=>navigate(-1)}>
        <BiSolidChevronLeftCircle className='text-[#252525] text-[36px]'/>
      </div>
        <div>
        <p className='text-[12px] font-medium capitalize tracking-[-.25px] text-gray-400'><Link to={'/'}>Home</Link> {parentLink ? '>' : null} <Link className='hover:text-[#2ac08b]' to={`/${parentLink}`}>{parentTitle}</Link></p>
        <h2 className='text-[14px] font-medium capitalize tracking-[-.15px]'>{title}</h2>
        </div>
        <RightContent/>
    </div>
  )
}
